export default __webpack_public_path__ + "static/media/Integrity.94c6f8bf.svg";